import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Globe, Users } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { Badge } from "@/components/ui/badge";

export default function TargetPicker({ groups, selected, setSelected, includePage, setIncludePage, pageConnected }) {
  const [tag, setTag] = useState("all");
  const tags = useMemo(() => [...new Set(groups.map((g) => g.tag))], [groups]);
  const shown = groups.filter((g) => tag === "all" || g.tag === tag);
  const allOn = shown.length > 0 && shown.every((g) => selected.includes(g.id));

  const toggle = (id) => setSelected(selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id]);
  const toggleAll = () => {
    const ids = shown.map((g) => g.id);
    setSelected(allOn ? selected.filter((x) => !ids.includes(x)) : [...new Set([...selected, ...ids])]);
  };

  return (
    <div className="space-y-4" data-testid="composer-targets-select">
      <label className={`flex cursor-pointer items-center gap-3 rounded-lg border p-3 transition-colors ${includePage ? "border-cyan-500/50 bg-cyan-500/10" : "border-border hover:bg-accent/40"}`}>
        <Checkbox checked={includePage} onCheckedChange={(v) => setIncludePage(!!v)} data-testid="composer-target-page-checkbox" />
        <Globe className="h-4 w-4 text-cyan-300" />
        <div className="flex-1">
          <p className="text-sm font-medium">Facebook Page saya</p>
          <p className="text-xs text-muted-foreground">{pageConnected ? "Dipost automatik" : <>Belum disambung — <Link to="/tetapan" className="text-primary hover:underline">sambung di Tetapan</Link></>}</p>
        </div>
      </label>

      <div className="flex flex-wrap items-center gap-2">
        {["all", ...tags].map((t) => (
          <button key={t} type="button" onClick={() => setTag(t)} className={`rounded-full border px-3 py-1 text-xs transition-colors ${tag === t ? "border-primary bg-primary/15 text-white" : "border-border text-muted-foreground hover:text-white"}`} data-testid={`composer-tag-filter-${t}`}>
            {t === "all" ? "Semua" : t}
          </button>
        ))}
        <button type="button" onClick={toggleAll} className="ml-auto text-xs text-primary hover:underline" data-testid="composer-select-all-btn">{allOn ? "Nyahpilih semua" : "Pilih semua"}</button>
      </div>

      <div className="max-h-72 space-y-1 overflow-y-auto pr-1">
        {groups.length === 0 && <p className="py-6 text-center text-sm text-muted-foreground">Tiada group. <Link to="/kumpulan" className="text-primary hover:underline">Tambah group</Link></p>}
        {shown.map((g) => (
          <label key={g.id} className={`flex cursor-pointer items-center gap-3 rounded-lg border px-3 py-2.5 transition-colors ${selected.includes(g.id) ? "border-primary/50 bg-primary/10" : "border-transparent hover:bg-accent/40"}`}>
            <Checkbox checked={selected.includes(g.id)} onCheckedChange={() => toggle(g.id)} data-testid={`composer-group-checkbox-${g.id}`} />
            <Users className="h-4 w-4 text-primary" />
            <span className="flex-1 truncate text-sm">{g.name}</span>
            {g.check_status === "inactive" && <Badge variant="outline" className="border-red-500/40 text-[10px] text-red-300">Tidak aktif</Badge>}
            <Badge variant="outline" className="border-border text-[10px] text-muted-foreground">{g.tag}</Badge>
          </label>
        ))}
      </div>
      <p className="font-mono text-xs text-muted-foreground" data-testid="composer-target-count">{selected.length + (includePage ? 1 : 0)} sasaran dipilih</p>
    </div>
  );
}
